import {useEffect, useState} from 'react';

export function useWindowInnerWidth() {
  const [innerWidth, setInnerWidth] = useState(0);
  useEffect(() => {
    const windowResizeListener = () => {
      setInnerWidth(window.innerWidth);
    };
    windowResizeListener();
    window.addEventListener('resize', windowResizeListener);
    return () => {
      window.removeEventListener('resize', windowResizeListener);
    };
  }, []);
  return innerWidth;
}
